export default {
    data: function () {
        return {
            scale: 0.3,
        }
    },

    methods: {
        changeScale(value) {
            if (value < 0 && this.scale.toFixed(1) <= 0.2) {
                return;
            } else if (value > 0 && this.scale.toFixed(1) >= 1.0) {
                return;
            }

            this.scale += value;
        },
    },
}
